import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  OnDestroy,
  OnChanges,
  SimpleChanges,
  ChangeDetectionStrategy,
  ElementRef,
  inject,
  ChangeDetectorRef,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { AioModalComponent } from '@aio/ui';

@Component({
  selector: 'app-coming-soon-feature-modal',
  standalone: true,
  imports: [CommonModule, AioModalComponent],
  templateUrl: './coming-soon-feature-modal.component.html',
  styleUrls: ['./coming-soon-feature-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ComingSoonFeatureModalComponent implements OnInit, OnDestroy, OnChanges {
  private readonly elementRef = inject(ElementRef<HTMLElement>);
  private readonly cdr = inject(ChangeDetectorRef);

  @Input() isOpen = false;
  /** Sidebar / nav label for the feature (e.g. "Integrations", "Pulse"). */
  @Input() featureLabel = '';

  @Output() close = new EventEmitter<void>();
  /** Fired when user chooses notify; parent should close the modal and show confirmation toast. */
  @Output() notifyMe = new EventEmitter<void>();

  isVisible = false;

  readonly supportEmail = 'team@AIOplatform.com';

  ngOnInit(): void {
    if (document.body) {
      document.body.appendChild(this.elementRef.nativeElement);
    }
    if (this.isOpen) {
      this.showModal();
    }
  }

  ngOnDestroy(): void {
    this.hideModal();
    const el = this.elementRef.nativeElement;
    if (el.parentNode) {
      el.parentNode.removeChild(el);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isOpen']) {
      if (this.isOpen) {
        this.showModal();
      } else {
        this.hideModal();
      }
    }
  }

  private showModal(): void {
    this.isVisible = true;
    document.body.style.overflow = 'hidden';
    this.cdr.markForCheck();
  }

  private hideModal(): void {
    this.isVisible = false;
    document.body.style.overflow = '';
    this.cdr.markForCheck();
  }

  handleOverlayClick(): void {
    this.hideModal();
    this.close.emit();
  }

  handleGotIt(): void {
    this.hideModal();
    this.close.emit();
  }

  handleNotifyMe(): void {
    this.hideModal();
    this.notifyMe.emit();
  }
}
